import React, { Component } from 'react';

import PropTypes from 'prop-types';

import { TrackEventContext } from 'common/containers/EventContainer';
import { ViewerContext } from 'common/containers/ViewerContainer';
import ZendeskLandingHelmet from 'common/helmets/ZendeskLandingHelmet';
import InstallExtensionButton from 'common/integrations/InstallExtensionButton';
import LandingFooterCTA from 'common/LandingFooterCTA';
import LazyLoadedImage from 'common/LazyLoadedImage';
import withContexts from 'common/util/withContexts';
import Zendesk1 from 'img/landing/zendesk-1.webp';
import Zendesk2 from 'img/landing/zendesk-2.webp';
import Zendesk3 from 'img/landing/zendesk-3.webp';

import ZendeskLogo from 'img/canny-zendesk-integration.png';

import 'css/components/integrations/_IntegrationsLanding.scss';
import 'css/components/_LandingFeatures.scss';

class ZendeskLanding extends Component {
  static propTypes = {
    trackEvent: PropTypes.func,
    viewer: PropTypes.shape({
      companies: PropTypes.array,
    }),
  };

  componentDidMount() {
    const { trackEvent } = this.props;
    trackEvent('Viewed Zendesk Integration Page');
  }

  render() {
    return (
      <div className="integrationsLanding">
        <ZendeskLandingHelmet />
        <div className="integrationsLandingContainer">
          <div className="header">
            <div className="left">
              <LazyLoadedImage className="appLogo" loading="eager" src={ZendeskLogo} />
              <div className="text">
                <h1 className="title">Canny for Zendesk</h1>
                <div className="subtitle">Capture feedback from Zendesk&nbsp;tickets</div>
                <div className="links">
                  <InstallExtensionButton
                    installLink="https://www.zendesk.com/apps/support/canny/"
                    installButtonText="Get started"
                  />
                  <a
                    href="http://help.canny.io/en/articles/3160421-zendesk-integration"
                    rel="noopener"
                    target="_blank"
                    className="LandingIntegrations__install-link">
                    See install docs
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="features">
            <div className="featureHighlight">
              <div className="featureImage">
                <LazyLoadedImage className="shadow" loading="eager" src={Zendesk2} />
              </div>
              <div className="featureText">
                <div className="title">Track feedback from within&nbsp;tickets</div>
                <div className="subtitle">
                  Don't let feedback slip through the cracks. Keep your product team informed and
                  your users&nbsp;happy.
                </div>
              </div>
            </div>
            <div className="featureHighlight">
              <div className="featureImage">
                <LazyLoadedImage className="shadow" src={Zendesk1} />
              </div>
              <div className="featureText">
                <div className="title">No need to leave&nbsp;Zendesk</div>
                <div className="subtitle">
                  Keep track of feedback without disrupting your current workflow. Search and create
                  Canny posts from&nbsp;Zendesk.
                </div>
              </div>
            </div>
            <div className="featureHighlight">
              <div className="featureImage">
                <LazyLoadedImage className="shadow" src={Zendesk3} />
              </div>
              <div className="featureText">
                <div className="title">All your feedback in one&nbsp;place</div>
                <div className="subtitle">
                  Canny keeps track of all votes that came from Zendesk tickets. Easily return to
                  the original ticket to give&nbsp;updates.
                </div>
              </div>
            </div>
          </div>
          <LandingFooterCTA style="solid" />
        </div>
      </div>
    );
  }
}

export default withContexts({
  trackEvent: TrackEventContext,
  viewer: ViewerContext,
})(ZendeskLanding);
